import React, { useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useHistory } from "react-router";
import { BrowserRouter as  Link } from "react-router-dom";
//import { AuthContext } from "../helpers/AuthContext";

function CreatePost() {
// const { authState } = useContext(AuthContext);

  let history = useHistory();
  const initialValues = {
    title: "",
    postText: "",
  };
  useEffect(() => {
    if (!localStorage.getItem("accessToken")) {
      history.push("/login");
    }
  }, [history]);
  const validationSchema = Yup.object().shape({
    title: Yup.string().required("You must input a Title!"),
    postText: Yup.string().required(),
  });
  const onSubmit = (data) => {
    axios
      .post("https://api.inloop.live/posts", data, {
        headers: { accessToken: localStorage.getItem("accessToken") },
      })
      .then((response) => {
        history.push("/");
      });
      alert("Expected payment of x-amount to be payed!");
      // <Link to="https://www.paypal.com/ncp/payment/YC5NSR8YE9Z96"></Link>
      window.location.replace("https://www.paypal.com/ncp/payment/YC5NSR8YE9Z96");
  };

  return (
    <div className="createPostPage">
      <h1>Create sponsor: </h1><br></br>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
        id="formForm"
        className="inputCreatePost"
      >
        <Form className="formContainer" id="formPost">
          <label for="inputTitle">Title: </label>
          <ErrorMessage name="title" component="span" />
          <Field
            autocomplete="off"
            id="inputTitle"
            name="title"
            placeholder="(Ex. Title...)"
            className="inputCreatePost"
          />
          <label for="inputBody">Post: </label>
          <ErrorMessage name="postText" component="span" />
          <Field
            autocomplete="off"
            id="inputBody"
            name="postText"
            placeholder="(Ex. Post...)"
            className="inputCreatePost"
          />
          <Link to="https://www.paypal.com/ncp/payment/YC5NSR8YE9Z96"></Link>
          <button type="submit"> Create Post</button>
        </Form>
      </Formik>
      
    </div>
  );
}

export default CreatePost;
